export const permissionsCadastroOperador = [
  process.env.VUE_APP_ADMINISTRADOR,
  process.env.VUE_APP_CALLCENTER_CADASTRO_OPERADOR_VISUALIZAR_CONDICIONADO,
  process.env.VUE_APP_CALLCENTER_CADASTRO_OPERADOR_EDITAR_CONDICIONADO,
  process.env.VUE_APP_CALLCENTER_CADASTRO_OPERADOR_TOTAL,
]

export const permissionsCadastroPausa = [
  process.env.VUE_APP_ADMINISTRADOR,
  process.env.VUE_APP_CALLCENTER_CADASTRO_PAUSA_VISUALIZAR_CONDICIONADO,
  process.env.VUE_APP_CALLCENTER_CADASTRO_PAUSA_EDITAR_CONDICIONADO,
  process.env.VUE_APP_CALLCENTER_CADASTRO_PAUSA_TOTAL,
]

export const permissionsCadastroFila = [
  process.env.VUE_APP_ADMINISTRADOR,
  process.env.VUE_APP_CALLCENTER_CADASTRO_FILA_VISUALIZAR_CONDICIONADO,
  process.env.VUE_APP_CALLCENTER_CADASTRO_FILA_EDITAR_CONDICIONADO,
  process.env.VUE_APP_CALLCENTER_CADASTRO_FILA_TOTAL,
]

export const permissionsCadastroDepartamento = [
  process.env.VUE_APP_ADMINISTRADOR,
  process.env.VUE_APP_CALLCENTER_CADASTRO_DEPARTAMENTO_VISUALIZAR_CONDICIONADO,
  process.env.VUE_APP_CALLCENTER_CADASTRO_DEPARTAMENTO_EDITAR_CONDICIONADO,
  process.env.VUE_APP_CALLCENTER_CADASTRO_DEPARTAMENTO_TOTAL,
]

export const permissionsRelatorioOperador = [
  process.env.VUE_APP_ADMINISTRADOR,
  process.env.VUE_APP_CALLCENTER_RELATORIO_OPERADOR_VISUALIZAR_CONDICIONADO,
  process.env.VUE_APP_CALLCENTER_RELATORIO_OPERADOR_OUVIR_GRAVACAO,
  process.env.VUE_APP_CALLCENTER_RELATORIO_OPERADOR_HISTORICO,
  process.env.VUE_APP_CALLCENTER_RELATORIO_OPERADOR_GRAVACAO_HISTORICO,
  process.env.VUE_APP_CALLCENTER_RELATORIO_OPERADOR_TOTAL,
]

export const permissionsRelatorioFila = [
  process.env.VUE_APP_ADMINISTRADOR,
  process.env.VUE_APP_CALLCENTER_RELATORIO_FILA_VISUALIZAR_CONDICIONADO,
  process.env.VUE_APP_CALLCENTER_RELATORIO_FILA_OUVIR_GRAVACAO,
  process.env.VUE_APP_CALLCENTER_RELATORIO_FILA_HISTORICO,
  process.env.VUE_APP_CALLCENTER_RELATORIO_FILA_OUVIR_GRAVACAO_HISTORICO,
  process.env.VUE_APP_CALLCENTER_RELATORIO_FILA_TOTAL,
]

export const permissionsRelatorioDisponibilidade = [
  process.env.VUE_APP_ADMINISTRADOR,
  process.env.VUE_APP_CALLCENTER_RELATORIO_DISPONIBILIDADE_VISUALIZAR_CONDICIONADO,
  process.env.VUE_APP_CALLCENTER_RELATORIO_DISPONIBILIDADE_TOTAL,
]

export const permissionsManutencaoOperadores = [
  process.env.VUE_APP_ADMINISTRADOR,
  process.env.VUE_APP_CALLCENTER_MANUTENCAO_VISUALIZAR,
]

export const permissionsMonitorFilas = [
  process.env.VUE_APP_ADMINISTRADOR,
  process.env.VUE_APP_CALLCENTER_MONITOR_VISUALIZAR,
  process.env.VUE_APP_CALLCENTER_MONITOR_PAUSA_DESPAUSA,
  process.env.VUE_APP_CALLCENTER_MONITOR_ADICIONAR_REMOVER_OPERADOR,
  process.env.VUE_APP_CALLCENTER_MONITOR_DESLOGAR_OPERADOR,
  process.env.VUE_APP_CALLCENTER_MONITOR_OUVIR_OPERADOR,
  process.env.VUE_APP_CALLCENTER_MONITOR_TOTAL,
]

export const permissionsConfigCallCenter = [
  process.env.VUE_APP_ADMINISTRADOR,
  process.env.VUE_APP_CALLCENTER_CONFIGURACAOMONITOROPERADOR_VISUALIZAR,
]

export const permissionsMonitorOperador = [
  process.env.VUE_APP_ADMINISTRADOR,
  process.env.VUE_APP_CALLCENTER_MONITOROPERADOR_VISUALIZAR_CONDICIONADO,
  process.env.VUE_APP_CALLCENTER_MONITOROPERADOR_TOTAL,
  process.env.VUE_APP_CALLCENTER_MONITOROPERADOR_PAUSA_DESPAUSA,
  process.env.VUE_APP_CALLCENTER_MONITOROPERADOR_REMOVER_FILA,
  process.env.VUE_APP_CALLCENTER_MONITOROPERADOR_DESLOGAR_OPERADOR,
  process.env.VUE_APP_CALLCENTER_MONITOROPERADOR_OUVIR_OPERADOR,
]
